const i18next = require('i18next');

const translate = (key) => {
  const result = i18next.t(key);
  console.log(result);
  return result;
};

module.exports = {
  translate
}